import useStyles from './useStyles'

function TableHeader () {
  const classes = useStyles()

  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headuser}>Usuario</th>
        <th className={classes.headName}>Nombre</th>
        <th className={classes.headDate}>Fecha de creación</th>
        <th className={classes.headstatus}>Estado</th>
      </tr>
    </thead>
  )
}

export default TableHeader
